const files = require.context('./svg-sprite', true, /.*\.svg$/);
files.keys().forEach(files);
